import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '@core/auth/auth-guard.service';
import { RouteAction } from '@core/action/action';
import { RoleEnum } from '@core/models/role';
import { DominiosListComponent } from './pages/dominios-list/dominios-list.component';
import { DominioListComponent } from './pages/dominio-list/dominio-list.component';
import { DominioFormComponent } from './pages/dominio-form/dominio-form.component';
import { DominioTreeListComponent } from './pages/dominio-tree-list/dominio-tree-list.component';



const routes: Routes = [

  {
    path: '',
    component: DominiosListComponent,
    canActivate: [AuthGuardService],
    data: {
      headerPage: {
        titlePage: '',
        subTitlePage: '',
      },
    },
  },
  {
    path: 'area-atuacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Área de Atuação',
        nome: 'AREA_ATUACAO'
      },
    },
  },
  {
    path: 'grupo-economico',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Grupo Econômico',
        nome: 'GRUPO_ECONOMICO'
      },
    },
  },
  {
    path: 'situacao-associada',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Situação Associada',
        nome: 'SITUACAO_ASSOCIADA'
      },
    },
  },
  {
    path: 'status-entidade',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Status de Entidade',
        nome: 'STATUS_ENTIDADE'
      },
    },
  },
  {
    path: 'status-validacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Status de Validação',
        nome: 'STATUS_VALIDACAO'
      },
    },
  },
  {
    path: 'tipo-comissao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Comissão',
        nome: 'TIPO_COMISSAO'
      },
    },
  },
  {
    path: 'tipo-contato',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Contato',
        nome: 'TIPO_CONTATO'
      },
    },
  },
  {
    path: 'tipo-documento',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Documento',
        nome: 'TIPO_DOCUMENTO'
      },
    },
  },
  {
    path: 'tipo-entidade',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Entidade',
        nome: 'TIPO_ENTIDADE'
      },
    },
  },
  {
    path: 'tipo-envolvimento',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Envolvimento',
        nome: 'TIPO_ENVOLVIMENTO'
      },
    },
  },
  {
    path: 'tipo-mudanca-entidade',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Mudança de Entidade',
        nome: 'TIPO_MUDANCA_ENTIDADE'
      },
    },
  },
  {
    path: 'tipo-operacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Operação',
        nome: 'TIPO_OPERACAO'
      },
    },
  },
  {
    path: 'tipo-orgao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Órgão',
        nome: 'TIPO_ORGAO'
      },
    },
  },
  {
    path: 'tipo-relacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Relação',
        nome: 'TIPO_RELACAO'
      },
    },
  },
  {
    path: 'tipo-vinculo',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo de Vínculo',
        nome: 'TIPO_VINCULO'
      },
    },
  },  {
    path: 'grupo',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Grupo',
        nome: 'GRUPO'
      },
    },
  },  {
    path: 'tipo-grupo',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo Grupo ',
        nome: 'TIPO_GRUPO'
      },
    },
  },
    {
    path: 'tipo-reguladora',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipo Reguladora',
        nome: 'TIPO_REGULADORA'
      },
    },
  },
  {
    path: 'cargo-referencia',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Cargo de Referência',
        nome: 'CARGO_REFERENCIA'
      },
    },
  },
  // {
  //   path: 'cargo-tipo-entidade',
  //   component: DominioListComponent,
  //   canActivate: [AuthGuardService],
  //   data: {
  //     dominio: {
  //       descricao: 'Cargo Por Tipo de Entidade',
  //       nome: 'CARGO_TIPO_ENTIDADE'
  //     },
  //   },
  // },
  {
    path: 'cargo-tipo-entidade',
    component: DominioTreeListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Cargo Por Tipo de Entidade',
        nome: 'CARGO_TIPO_ENTIDADE'
      },
    },
  },
  {
    path: 'tratamento',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tratamento',
        nome: 'TRATAMENTO'
      },
    },
  },
  {
    path: 'lotacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Lotação',
        nome: 'LOTACAO'
      },
    },
  },
  {
    path: 'grupo-atualizacao',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Grupo de Atualização',
        nome: 'GRUPO_ATUALIZACAO'
      },
    },
  },
  {
    path: 'sub-tipo-entidade',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Sub Tipo de Entidade',
        nome: 'SUB_TIPO_ENTIDADE'
      },
    },
  },
  {
    path: 'especializacao-sub-tipo-entidade',
    component: DominioListComponent,
    canActivate: [AuthGuardService],
    data: {
      dominio: {
        descricao: 'Tipos do subTipo de Entidade',
        nome: 'ESPECIALIZACAO_SUB_TIPO_ENTIDADE'
      },
    },
  },
  {
    path: ':nomeDominio/cadastrar',
    component: DominioFormComponent,
    data: {
      acao: RouteAction.Inserir
    },
  },
  {
    path: ':nomeDominio/editar/:id',
    component: DominioFormComponent,
    data: {
      acao: RouteAction.Editar,
    },
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DominiosRoutingModule { }
